module.exports = __webpack_public_path__ + "static/media/set_active_NYC_22.5cb20150.png";